import { render, staticRenderFns } from "./QuickInvoiceItems.vue?vue&type=template&id=f37e5578&scoped=true"
import script from "./QuickInvoiceItems.vue?vue&type=script&lang=js"
export * from "./QuickInvoiceItems.vue?vue&type=script&lang=js"
import style0 from "./QuickInvoiceItems.vue?vue&type=style&index=0&id=f37e5578&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37e5578",
  null
  
)

export default component.exports